export default "__VITE_ASSET__DVOiRYdN__"